import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
import { getFormattedDateTime, buildFilterString } from "@ane/exp-data/lib/resources/expapiunified/ExpApiVUnified.utils";
const transformContextToQuery = (context, rootEG) => {
  const filters = {
    top: context.pageSize,
    skip: (context.page - 1) * context.pageSize,
    keywordSearch: context.keywordSearch,
    subscriber: context.subscriber,
    experimentationGroup: !context.experimentationGroup ? rootEG : context.experimentationGroup.length === 1 ? context.experimentationGroup[0] : context.experimentationGroup,
    isolationGroups: context.isolationGroups,
    status: context.statuses,
    fromDateTime: getFormattedDateTime(context.startedAfter),
    toDateTime: getFormattedDateTime(context.startedBefore),
    isArchived: context.isArchived,
    collapseRolloutTargetsIntoRoot: context.collapseRolloutTargetsIntoRoot,
    onlyLoadFeatureData: EnvironmentService.enableMoreColumnsOnFeatureListPage() && EnvironmentService.useFalseForOnlyLoadFeatureData() ? false : context.onlyLoadFeatureData
  };
  const filterString = buildFilterString(context.workspaceId, filters);
  const params = new URLSearchParams(filterString);
  const result = {};
  for (const [key, value] of params.entries()) {
    result[key] = value === "true" ? true : value === "false" ? false : value;
  }
  return result;
};
export {
  transformContextToQuery
};
//# sourceMappingURL=utils.js.map
